import script from "./ProjectHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectHistory.vue?vue&type=script&setup=true&lang=js"

import "./ProjectHistory.vue?vue&type=style&index=0&id=0a2d21e3&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2d21e3"]])

export default __exports__